import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1022 1245" {...props}><path d="M0 1245V0h686l336 344v901zm147-147h727V393H610V147H147zm101-154h520v-57H248zm0-164h520v-57H248zm0-164h520v-57H248z" /></svg>;